import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, CargoQuantityUnit, PayableOver } from "__generated__/graphql";

export const WeightRangeSchema: RegistryItem = {
	[AgreementTypeEnum.WeightRange]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.CargoQuantity,
				cargoQuantityUnit: CargoQuantityUnit.Mton,
				payableOver: PayableOver.Actual,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.cargoQuantityUnit": { rules: { hidden: true } },
			"calculationMethod.price": { rules: { hidden: true } },
			"calculationMethod.minimumPrice": { rules: { hidden: true } },
			"calculationMethod.minimumQuantityPayable": { rules: { hidden: true } },
		},
	},
};
